import {RouteNameEnum} from "@/v2/enumerate/route";

const team = [{
	path: "team",
	name: RouteNameEnum.GLORY_TEAM,
	meta: {
		permission: 63001,
		breadcrumb: [{
			key: "glory.team.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/team/index.vue"),
}];

export default team;
